<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div
      class="constrained-content flex-space-between"
      style="align-items: center"
    >
      Upgrade to track Microsoft Teams conversations
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'startup' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-grid>
      <ion-row>
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1>
            <ion-icon name="custom-teams"></ion-icon>Microsoft Teams
            <ion-badge color="warning" style="font-size: 0.5rem"
              >BETA</ion-badge
            >
          </h1>
          <p class="subtitle">
            Forward Microsoft Teams messages into a channel, discuss internally,
            and send replies right from Slack or your Unthread dashboard.
          </p>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <a (click)="showMicrosoftTeamsHelpdesk()">
              Learn more about integrating Microsoft Teams
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </a>
          </p>
          <p class="subtitle" style="opacity: 1; margin-bottom: 15px">
            <ion-badge color="warning" *ngIf="!hasMicrosoftTeamsConnections">
              Not configured yet
            </ion-badge>
            <ion-badge color="success" *ngIf="hasMicrosoftTeamsConnections">
              Enabled
            </ion-badge>
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <div
            *ngIf="
              !hasMicrosoftTeamsConnections && externalChatConnections?.length
            "
          >
            <h3 style="margin: 20px">Create your first Teams connection</h3>
            <ion-card class="outline-card">
              <ion-list>
                <ion-item>
                  <ion-label>
                    <h3>Step 1: Choose a Slack channel</h3>
                    <p>This is where new messages will be cross-posted</p>
                  </ion-label>
                  <app-channel-selector
                    [channel]="externalChatConnections[0].slackChannel"
                    (channelDidChange)="
                      onConnectionChannelChanged(
                        externalChatConnections[0],
                        $event,
                        0
                      )
                    "
                    [defaultInternalOnly]="true"
                  ></app-channel-selector>
                </ion-item>
                <ion-item *ngIf="externalChatConnections[0].slackChannel">
                  <ion-label>
                    <h3>Step 2: Connect with Teams</h3>
                    <p>This will prompt a Microsoft approval dialog</p>
                  </ion-label>
                  <ion-button
                    fill="outline"
                    (click)="save(0)"
                    [disabled]="!featureEnabled"
                  >
                    Connect to Teams
                  </ion-button>
                </ion-item>
              </ion-list>
            </ion-card>
          </div>
          <div *ngIf="hasMicrosoftTeamsConnections">
            <ion-card
              class="outline-card"
              *ngFor="let connection of externalChatConnections; let i = index"
              style="margin: 10px 10px 30px 10px"
            >
              <div *ngIf="showingIndex !== i">
                <h3 style="margin: 20px 20px 5px 20px">
                  {{ connection.name }}
                </h3>
                <ion-list>
                  <ion-item>
                    <ion-icon
                      name="logo-slack"
                      class="list-left-icon"
                    ></ion-icon>
                    Slack channel: #{{ connection.slackChannel?.name }}
                  </ion-item>
                  <ion-item>
                    <ion-icon
                      name="ellipse"
                      [color]="connection.enabled ? 'success' : 'warning'"
                      class="list-left-icon"
                    ></ion-icon>
                    Status: {{ connection.enabled ? "active" : "inactive" }}
                  </ion-item>
                </ion-list>
                <div class="flex-space-between">
                  <ion-button fill="clear" (click)="viewInbox(connection)">
                    <ion-icon
                      name="file-tray-outline"
                      class="padded-icon"
                    ></ion-icon>
                    View conversations
                  </ion-button>
                  <ion-button fill="clear" (click)="toggleShowing(i)">
                    <ion-icon name="cog-outline" class="padded-icon"></ion-icon>
                    Edit configuration
                  </ion-button>
                </div>
              </div>
              <div *ngIf="showingIndex === i">
                <ion-card-header *ngIf="connection.id">
                  <ion-input
                    [(ngModel)]="connection.name"
                    class="input-field big-title-input"
                    placeholder="Name your inbox (ex: 'Microsoft Teams')"
                    autocapitalize="sentences"
                    (click)="showingIndex = i"
                  >
                  </ion-input>
                </ion-card-header>

                <ion-list>
                  <ion-item>
                    <h3 class="list-header">Settings</h3>
                  </ion-item>
                  <ion-item>
                    <ion-label>Enabled: </ion-label>
                    <label class="switch" slot="end">
                      <input type="checkbox" [(ngModel)]="connection.enabled" />
                      <span class="slider"></span>
                    </label>
                  </ion-item>
                  <ion-item>
                    <ion-label>Post to Slack channel: </ion-label>
                    <div slot="end">
                      <app-channel-selector
                        [channel]="connection.slackChannel"
                        (channelDidChange)="
                          onConnectionChannelChanged(connection, $event, i)
                        "
                        [defaultInternalOnly]="true"
                      ></app-channel-selector>
                    </div>
                  </ion-item>
                  <ion-item>
                    <ion-label>Teams channels to track: </ion-label>
                    <ion-label slot="end">
                      <div
                        style="
                          display: flex;
                          height: 100%;
                          align-items: center;
                          margin: 5px;
                        "
                      >
                        <div
                          class="round-pill-tab round-pill-tab-right"
                          [ngClass]="{
                            'round-pill-tab-active':
                              !connection.channelAllowlistEnabled
                          }"
                          (click)="connection.channelAllowlistEnabled = false"
                          style="flex-grow: 1"
                        >
                          Listen to all channels
                        </div>
                        <div
                          class="round-pill-tab round-pill-tab-left"
                          [ngClass]="{
                            'round-pill-tab-active':
                              connection.channelAllowlistEnabled
                          }"
                          (click)="connection.channelAllowlistEnabled = true"
                          style="flex-grow: 1"
                        >
                          Restrict to specific channels
                        </div>
                      </div>
                    </ion-label>
                  </ion-item>
                  <ion-list *ngIf="connection.channelAllowlistEnabled">
                    <ion-item>
                      <h3 class="list-header">Teams Channel Allowlist</h3>
                    </ion-item>
                    <ion-item
                      *ngFor="
                        let entry of connection.channelAllowlist;
                        let j = index
                      "
                    >
                      {{ entry }}
                      <ion-button
                        slot="end"
                        (click)="removeFromAllowlist(connection, j)"
                        color="light"
                        >Remove</ion-button
                      >
                    </ion-item>
                    <ion-item>
                      <ion-input
                        placeholder="Enter Team name..."
                        [(ngModel)]="newAllowlistTeam"
                      ></ion-input>
                      <ion-input
                        placeholder="Enter Channel name..."
                        [(ngModel)]="newAllowlistChannel"
                      ></ion-input>
                      <ion-button (click)="addToAllowlist(connection)"
                        >Add</ion-button
                      >
                    </ion-item>
                  </ion-list>
                </ion-list>
                <ion-card-title class="card-title">
                  <h3 class="list-header">Connected Teams Users</h3>
                  <p class="subtitle">
                    Replies sent back to Microsoft Teams will be sent from the
                    user you select here.
                  </p>
                </ion-card-title>
                <ion-list>
                  <ion-item
                    *ngFor="let user of connectedUsers; trackBy: trackById"
                  >
                    {{ user.name }}
                  </ion-item>
                  <ion-item>
                    <ion-button fill="outline" (click)="addConnectedUser(i)">
                      <ion-icon
                        name="add-outline"
                        class="padded-icon"
                      ></ion-icon>
                      Connect
                    </ion-button>
                  </ion-item>
                </ion-list>

                <ion-card-title class="card-title">
                  <h3 class="list-header">SLA</h3>
                </ion-card-title>
                <app-support-steps
                  [initialSupportSteps]="connection.supportSteps"
                  (didChange)="supportStepsDidChange($event, i)"
                >
                </app-support-steps>

                <ion-card-title
                  class="card-title flex-space-between"
                  style="align-items: center"
                >
                  <h3 style="margin-bottom: 18px" class="list-header">
                    Autoresponder
                  </h3>
                </ion-card-title>

                <app-autoresponder
                  [isDefault]="false"
                  [initialAutoresponder]="connection.autoresponder"
                  (autoresponderDidChange)="
                    autoresponderDidChange(connection, $event)
                  "
                  [projectId]="projectId ?? undefined"
                ></app-autoresponder>

                <div class="border-top">
                  <ion-button
                    color="success"
                    (click)="save(i)"
                    class="save-button"
                    [disabled]="!featureEnabled"
                  >
                    {{ connection.id ? "Save changes" : "Connect" }}
                  </ion-button>
                  <ion-button
                    fill="clear"
                    (click)="toggleShowing(i)"
                    *ngIf="hasMicrosoftTeamsConnections"
                  >
                    Cancel
                  </ion-button>
                  <ion-button
                    color="danger"
                    fill="clear"
                    (click)="delete(i)"
                    *ngIf="connection.id"
                    >Delete</ion-button
                  >
                </div>
              </div>
            </ion-card>
          </div>

          <ion-button
            fill="clear"
            size="block"
            class="btn-large"
            style="margin: 32px 12px"
            (click)="addConnection()"
            *ngIf="
              hasMicrosoftTeamsConnections &&
              externalChatConnections[externalChatConnections.length - 1].id
            "
          >
            <ion-icon name="add-outline" class="padded-icon"></ion-icon>Add
            another Microsoft Teams connection
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
